<template>
    <div class="contributeUeditor">
        <div class="content">
            <vueUeditorWrap :config="config" v-model="detail" @ready="ready" :destroy="true"></vueUeditorWrap>
        </div>
    </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import $ from 'jquery'
const _url = window.location.origin
export default {
    name: 'uEditor',
    data() {
        return {
            editor: null, // uEditor实例
            detail: '',
            title: '',
            config: {
                autoHeightEnabled: true, // 编辑器自动被内容撑高
                initialFrameHeight: 300, // 初始容器高度
                initialFrameWidth: '100%', // 初始容器宽度
                autoFloatEnabled: true, // 工具栏悬浮
                topOffset: 70,
                initialContent: '', // 默认内容
                elementPathEnabled: false, // 元素路径
                wordCount: false, // 字数统计
                // enableAutoSave: false, // 自动保存
                // autoSyncData: false, // 自动同步编辑器要提交的数据
                // enableContextMenu: false, // 右键菜单
                // pasteplain: false, // 是否默认为纯文本粘贴
                // catchRemoteImageEnable: false, // 远程图片抓取关闭
                // imagePopup: false, // 图片操作的浮层开关，默认打开
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                serverUrl: `${_url}/api/ue/uploadEditorImage`,
                configUrl: `${_url}/api/ue/getConfig`,
                UEDITOR_HOME_URL: '/UEditor/', // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                toolbars: [
                    [
                        'source', // 源代码
                        '|',
                        'undo', // 前进
                        'redo', // 后退
                        '|',
                        'fontfamily', // 字体
                        'fontsize', // 大小
                        'bold', // 加粗
                        'forecolor', // 字体颜色
                        'italic', // 斜体
                        'underline', // 下划线
                        '|',
                        'justifyleft', // 左对齐
                        'justifycenter', // 居中
                        'justifyright', // 右对齐
                        'lineheight', // 行间距
                        '|',
                        'insertunorderedlist', // 无序列表
                        'directionalityltr', // 从左向右输入
                        'directionalityrtl', // 从右向左输入
                        '|',
                        'simpleupload', // 图片
                        'link' // 链接
                    ]
                ],
                lineheight: ['1', '1.5', '1.75', '2', '3', '4', '5'] // 行高
            }
        }
    },
    props: ['placeholder'],
    mounted() {

    },
    methods: {
        insert(str) {
            this.editor.focus()
            this.editor.execCommand('inserthtml', str)
        },
        ready (editorInstance) {
            let _this = this
            this.editor = editorInstance
            // console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
            if (!$.trim(this.detail)) {
                if (this.placeholder) this.detail = `<span class="ue_zj_placeholder">${this.placeholder}</span>`
            }
            if (this.placeholder) {
                $(this.editor.body).on('focus', function () {
                    $(this).find('.ue_zj_placeholder').remove()
                })
                $(this.editor.body).on('blur', function () {
                    if (!$.trim(_this.detail)) {
                        _this.detail = `<span class="ue_zj_placeholder">${_this.placeholder}</span>`
                    }
                })
            }
            $(this.editor.body).on('click', '.ue_zj_btn', function () {
                $(this).parent().remove()
            })
            // 这一块是针对投稿的处理
            $(this.editor.document.documentElement).addClass('specialContributeHtml')
            $(this.editor.body).addClass('specialContribute')
            $(`<div class="articleTitle">
                <input type="text" id="articleTitle" autocomplete="off" placeholder="请输入标题(5-90字)" maxlength="90" class="articleTitleInput">
                <div class='titleCount' id="titleCount">0/90</div>
            </div>`).insertAfter('.edui-editor-toolbarbox')
            if (this.title) {
                document.getElementById('articleTitle').value = this.title
                document.getElementById('titleCount').innerText = this.title.length + '/90'
            }
            document.getElementById('articleTitle').addEventListener('input', (event) => {
                this.title = event.target.value
                this.$emit('getUEditorContent', {detail: this.detail, title: this.title})
                document.getElementById('titleCount').innerText = event.target.value.length + '/90'
            })
        },
        init(content, title) {
            this.detail = content
            this.title = title
            if (this.title && document.getElementById('articleTitle')) {
                document.getElementById('articleTitle').value = this.title
                document.getElementById('titleCount').innerText = this.title.length + '/90'
            }
        }
    },
    filters: {},
    watch: {
        detail() {
            // if (this.detail !== '<p><span class="ue_zj_placeholder">请输入正文内容</span></p>' && this.detail !== '<span class="ue_zj_placeholder">请输入正文内容</span>') {
                this.$emit('getUEditorContent', {detail: this.detail, title: this.title})
            // }
        }
    },
    computed: {},
    components: {
        VueUeditorWrap
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .contributeUeditor {
        .content {
            &>* {
                width: 100%;
            }
        }
        .editor.options.elementPathEnabled{
            display: none !important;
        }
        .ue_zj_box{
            line-height: 1;
            width: calc(100% - 20px);
            padding: 10px;
            background: #F5F5F5;
            position: relative;
            .ue_zj_content{
                display: flex;
                .ue_zj_image{
                    margin-right: 10px;
                    position: relative;
                    width: 82px;
                    height: 60px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .ue_zj_label{
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        display: inline-block;
                        padding: 3px 6px;
                        color: #fff;
                        font-size: 12px;
                        background: #909399;
                    }
                }
                .ue_zj_summary{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .ue_zj_title{
                        .ue_zj_name{
                            font-size: 14px;
                            color: #303133;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap
                        }
                    }
                    .ue_zj_price{
                        color: #F56C6C;
                    }
                }
            }
            .ue_zj_btn{
                position: absolute;
                top: calc(50% - 10px);
                right: 0;
                margin: 0 10px;
                width: 20px;
                height: 20px;
                display: none;
                /*background: url(./default/images/zj_icon/del.png);*/
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        .ue_zj_box{
            &:hover{
                .ue_zj_btn{
                    display: block;
                }
            }
        }
        .ue_btn{
            margin-left: 8px;
            .el-button{
                display: block;
                margin: 0;
                width: 154px;
                height: 54px;
                border-radius: 0;
                border-width: 0;
                border: 1px solid #DDDDDD;
            }
            .el-button~.el-button{
                border-top: 0px solid #DDDDDD;
            }
        }
        .content{
            display: flex;
        }
        // .edui-editor-toolbarbox {
        //     position: fixed !important;
        //     width: calc(100vw - 240px);
        // }
        .edui-default .edui-editor,
        .edui-default .edui-editor-iframeholder {
            width: 100% !important;
            // height: auto !important;
        }
        .edui-editor-toolbarbox{
            box-shadow: none !important;
            background: #FAFAFA !important;
            border-bottom: none !important;
        }
        .edui-default .edui-editor-toolbarboxouter {
            box-shadow: none !important;
            background: #FAFAFA !important;
            border-bottom: none !important;
        }
        .edui-default .edui-editor {
            box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.14);
        }
        .articleTitle {
            padding: 0 30px 10px;
            position: relative;
            width: 100%;
            box-sizing: border-box;
            .articleTitleInput {
                width: 96%;
                height: 68px;
                font-size: 20px;
                padding: 20px 0;
                outline: none;
                border-bottom: 1px solid #EEEEEE;
                box-sizing: border-box;
                font-weight: bold;
                &::placeholder {
                    font-weight: 400;
                    color: #999999;
                }
            }
            .titleCount {
                position: absolute;
                font-size: 20px;
                color: #999999;
                right: 30px;
                top: 25px;
            }
        }
        .view {
            padding-top: 50px;
            overflow: hidden !important;
        }
        .edui-default .edui-editor{
            box-sizing: border-box;
        }
        .el-dialog{
            min-height: 500px;
            line-height: 1 !important;
            img{
                max-width: 100% !important;
            }
            .preview{
                min-height: 500px;
                video{
                    width: 100%;
                }
            }
            .noPreview{
                height: 500px;
                text-align: center;
                line-height: 500px;
                color: #ccc;
            }
        }
        .view{
            .zxr{
                width: 100px;
                height: 100px;
            }
        }
    }
</style>
